import React from 'react';
import './PageStatus.css';

export function PageLoading({ message = 'Loading…', className = '' }) {
  return (
    <div className={`page-status page-status--loading ${className}`.trim()} role="status" aria-live="polite">
      <div className="page-status-spinner" aria-hidden="true" />
      <p className="page-status-message">{message}</p>
    </div>
  );
}

export function PageError({
  title = 'Something went wrong',
  message,
  onRetry,
  retryLabel = 'Try again',
  children,
  className = '',
}) {
  return (
    <div className={`page-status page-status--error ${className}`.trim()} role="alert">
      <h2 className="page-status-title">{title}</h2>
      {message && <p className="page-status-message">{message}</p>}
      {onRetry && (
        <button type="button" className="btn btn-outline-primary page-status-retry" onClick={onRetry}>
          {retryLabel}
        </button>
      )}
      {children}
    </div>
  );
}

export function PageEmpty({
  title = 'Nothing here yet',
  message,
  children,
  className = '',
}) {
  return (
    <div className={`page-status page-status--empty ${className}`.trim()}>
      <h2 className="page-status-title">{title}</h2>
      {message && <p className="page-status-message">{message}</p>}
      {children}
    </div>
  );
}
